/**
 *
 */

var Slider = (function($) {
  function initClientsSlider() {
    var swiper = new Swiper(".clients-slider", {
      slidesPerView: "auto",
      spaceBetween: 30,
      slideToClickedSlide: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
  }

  function initHomeSlider() {
    var swiper = new Swiper(".home-slider", {
      slidesPerView: "2",
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      768: {
        slidesPerView: "3",
        spaceBetween: 20
      }
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".swiper").length) {
      return;
    }

    initClientsSlider();
    initHomeSlider();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Slider.init);
